import React from "react"
import { Link } from "gatsby"
import { Section, Container, Content } from "bloomer"
import Layout from "../components/layout"
import SEO from "../components/seo"

const CONTATO = "santiago@boraventures.com"

const PrivacidadePage = () => (
  <Layout noAds>
    <SEO
      title="Política de Privacidade e Termos de Uso - EstrelaGuia"
      description="Como o EstrelaGuia usa cookies, Google Analytics e Google AdSense; seus direitos pela LGPD; e o aviso de que nosso conteúdo é entretenimento."
      pathname="/politica-de-privacidade/"
    />
    <Section>
      <Container>
        <Content>
          <h1>Política de Privacidade e Termos de Uso</h1>
          <p><em>Última atualização: setembro de 2026</em></p>
          <p>
            O <strong>EstrelaGuia</strong> (estrelaguia.com.br) é um portal de horóscopo,
            astrologia e oráculos operado por Santiago Pehar Riveiro (Montevidéu, Uruguai).
            Esta página explica quais dados são tratados quando você navega no site e quais
            são os seus direitos.
          </p>

          <h2>Conteúdo de entretenimento</h2>
          <p>
            Horóscopo, mapa astral, tarot, baralho cigano, runas, cristais, numerologia e
            anjos são <strong>tradições simbólicas</strong>, oferecidas aqui para reflexão e
            entretenimento. Nada neste site substitui
            orientação médica, psicológica, jurídica ou financeira. As decisões são sempre
            suas.
          </p>

          <h2>Dados que o site trata</h2>
          <ul>
            <li>
              <strong>Google Analytics 4</strong> — estatísticas de navegação (páginas
              vistas e interações), com cookies e um identificador pseudonimizado
              de navegador. Não coletamos nome, e-mail ou telefone no site.
            </li>
            <li>
              <strong>Google AdSense</strong> — anúncios que podem usar cookies para
              personalização. Você pode ajustar isso em{" "}
              <a href="https://adssettings.google.com" target="_blank" rel="noopener noreferrer">
                adssettings.google.com
              </a>
              . Veja também{" "}
              <a href="https://policies.google.com/technologies/partner-sites" target="_blank" rel="noopener noreferrer">
                como o Google usa dados de sites parceiros
              </a>
              .
            </li>
            <li>
              <strong>Fontes e imagens</strong> — as fontes do site são servidas pelo Google
              Fonts e as imagens dos artigos pelo Unsplash; ao carregar a página, esses
              serviços recebem o endereço IP do seu navegador, como qualquer recurso web.
            </li>
            <li>
              <strong>Cookies técnicos</strong> — o site pode guardar no seu navegador
              preferências simples (por exemplo, que você já fechou um aviso).
            </li>
          </ul>

          <h2>Seus direitos (LGPD)</h2>
          <p>
            Nos termos da Lei Geral de Proteção de Dados (Lei 13.709/2018), você pode pedir
            acesso, correção ou exclusão dos dados relacionados a você, e pode desativar os
            cookies no seu navegador. Encarregado (DPO) e contato:{" "}
            <a href={`mailto:${CONTATO}`}>{CONTATO}</a>.
          </p>

          <h2>Termos de uso</h2>
          <p>
            Os textos, imagens e jogos do EstrelaGuia são de uso pessoal e não comercial.
            Os jogos de oráculo sorteiam cartas aleatoriamente e não guardam resultados.
            Podemos atualizar esta página a qualquer momento; a data no topo indica a versão
            vigente.
          </p>
          <p>
            <Link to="/">Voltar à página inicial</Link>
          </p>
        </Content>
      </Container>
    </Section>
  </Layout>
)

export default PrivacidadePage
